module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zbsp-box"
  }, [_c('div', {
    staticClass: "zbsp-table"
  }, [_c('div', {
    staticClass: "zbsp-table-header"
  }, [_c('span', {
    staticClass: "zbsp-col zbsp-col-num"
  }, [_vm._v(_vm._s(_vm.$t('all.shangpinxuhao')))]), _vm._v(" "), _c('span', {
    staticClass: "zbsp-col zbsp-col-img"
  }, [_vm._v(_vm._s(_vm.$t('all.shangpinshoutu')))]), _vm._v(" "), _c('span', {
    staticClass: "zbsp-col zbsp-col-name"
  }, [_vm._v(_vm._s(_vm.$t('all.shangpinmingcheng')))]), _vm._v(" "), _c('span', {
    staticClass: "zbsp-col zbsp-col-stock"
  }, [_vm._v("UNImall " + _vm._s(_vm.$t('all.shangchengkucun')))]), _vm._v(" "), _c('span', {
    staticClass: "zbsp-col zbsp-col-live-stock"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibokucun')))]), _vm._v(" "), _c('span', {
    staticClass: "zbsp-col zbsp-col-price"
  }, [_vm._v("UNImall " + _vm._s(_vm.$t('all.shangchengjiage')))]), _vm._v(" "), _c('span', {
    staticClass: "zbsp-col zbsp-col-live-price"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojiage')))]), _vm._v(" "), _c('span', {
    staticClass: "zbsp-col zbsp-col-action"
  }, [_vm._v(_vm._s(_vm.$t('all.caozuo')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbsp-table-body"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "zbsp-table-row"
    }, [_c('span', {
      staticClass: "zbsp-col zbsp-col-num"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('span', {
      staticClass: "zbsp-col zbsp-col-img"
    }, [_c('img', {
      staticClass: "zbsp-product-img",
      attrs: {
        "src": item.imgUrl,
        "alt": ""
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "zbsp-col zbsp-col-name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "zbsp-col zbsp-col-stock"
    }, [_vm._v(_vm._s(item.mallStock))]), _vm._v(" "), _c('span', {
      staticClass: "zbsp-col zbsp-col-live-stock"
    }, [_c('div', {
      staticClass: "zbsp-counter"
    }, [_c('img', {
      staticClass: "zbsp-counter-btn",
      attrs: {
        "src": require("../../../assets/image/shuliang_jian@2x.png"),
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.decreaseLiveStock(item)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "zbsp-counter-value"
    }, [_vm._v(_vm._s(item.liveStock))]), _vm._v(" "), _c('img', {
      staticClass: "zbsp-counter-btn",
      attrs: {
        "src": require("../../../assets/image/shuliang_jia@2x.png"),
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.increaseLiveStock(item)
        }
      }
    })])]), _vm._v(" "), _c('span', {
      staticClass: "zbsp-col zbsp-col-price"
    }, [_vm._v(_vm._s(item.mallPrice))]), _vm._v(" "), _c('span', {
      staticClass: "zbsp-col zbsp-col-live-price"
    }, [_c('div', {
      staticClass: "zbsp-counter"
    }, [_c('img', {
      staticClass: "zbsp-counter-btn",
      attrs: {
        "src": require("../../../assets/image/shuliang_jian@2x.png"),
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.decreaseLivePrice(item)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "zbsp-counter-value"
    }, [_vm._v(_vm._s(item.livePrice))]), _vm._v(" "), _c('img', {
      staticClass: "zbsp-counter-btn",
      attrs: {
        "src": require("../../../assets/image/shuliang_jia@2x.png"),
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.increaseLivePrice(item)
        }
      }
    })])]), _vm._v(" "), _c('span', {
      staticClass: "zbsp-col zbsp-col-action"
    }, [_c('span', {
      staticClass: "zbsp-remove",
      on: {
        "click": function($event) {
          return _vm.handleRemove(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('all.yichu')))])])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43405ffa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/zhiboshangpin/zhiboshangpin.vue
// module id = 965
// module chunks = 1